import { render } from "./MessageBlock.vue?vue&type=template&id=6a49f4aa&scoped=true"
import script from "./MessageBlock.vue?vue&type=script&lang=js"
export * from "./MessageBlock.vue?vue&type=script&lang=js"

import "./MessageBlock.vue?vue&type=style&index=0&id=6a49f4aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a49f4aa"]])

export default __exports__